type Props = Readonly<{
  ticker: string;
}>;

export function TokenLogo({ ticker }: Props): JSX.Element {
  const extension = ticker === "SBC" ? "svg" : "png";

  return (
    <img
      alt={ticker}
      src={`/assets/stablecoins/${ticker.toLocaleLowerCase()}-logo.${extension}`}
      className="h-6 w-6"
    />
  );
}
